<template>
  <div>
    <div id="headeradmin" class="row m-0">
      <div class="col-12">
        <div class="row">
          <div class="col-2">
            <img
              class="pl-4 pt-3 img-fluid"
              src="../assets/imgs/admin/encauce-logo.png"
              alt="Encauce"
            />
          </div>

          <div class="col-6 amarillo ml-5 pl-4 d-flex" v-if="userProfile">
            <div
              class="logo"
              v-if="userProfile.logo != undefined && userProfile.logo != ''"
            >
              <img class="pl-4 py-4" :src="userProfile.logo" alt="Encauce" />
            </div>
            <div class="ml-4 pt-3">
              {{ userProfile.nombre }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 pt-4" v-if="userProfile.institucion != undefined && userProfile.institucion != ''">
        <span class="fpG blanco">
          Institución seleccionada: {{ userProfile.institucion_nombre }}
        </span>
      </div>

     

      

      <!-- <div class="col-12">
        <b-button v-b-toggle.sidebar-1>
          <svg
            height="32px"
            id="Layer_1"
            style="enable-background: new 0 0 32 32"
            version="1.1"
            viewBox="0 0 32 32"
            width="32px"
            xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path
              d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
            />
          </svg>
        </b-button>
      </div> -->
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 36;
import Footer from "@/components/Footer";
import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import * as fb from "../../firebase";
import * as moment from "moment";
import { misionesCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  methods: {
    logout() {
      this.$store.dispatch("logoutAdmin");
    },
  },
};
</script>

<style scoped>
</style>
